module.exports = __webpack_public_path__ + "static/media/order.98656b9a.svg";